export default {
      id: "Group-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Group",
      toString: function () {
        return this.url;
      }
    }